function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "instat_analysis");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M677.58565,318.16144c-.88359,2.08758-1.74737,4.22848-2.56748,6.36211l-2.1462-.82494c.82936-2.15773,1.70254-4.32148,2.59591-6.433Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1054.8968,470.53711c-1.10891,2.885-2.29205,5.76915-3.51673,8.57358l-2.107-.92054c1.834-4.19879,3.56244-8.55482,5.11622-12.89138l2.16473.77673Q1055.75357,468.30812,1054.8968,470.53711Zm5.94-17.81646-2.21275-.62679c1.25843-4.43806,2.37593-8.96637,3.32417-13.46112l2.24947.47493C1063.23866,443.65239,1062.10851,448.23237,1060.8368,452.72065Zm-15.49689,39.04416c-2.15216,4.13784-4.47109,8.24646-6.89266,12.21219l-1.96155-1.199c2.39322-3.92009,4.68588-7.98228,6.81322-12.07433Zm21.27772-66.46942-2.27781-.31984c.63838-4.55852,1.12513-9.19817,1.44656-13.7895l2.29358.15991C1067.75466,415.99114,1067.263,420.68423,1066.61763,425.29539ZM1030.73,515.687c-2.69285,3.7953-5.55538,7.547-8.50644,11.15047l-1.77862-1.45583c2.918-3.56442,5.74735-7.27358,8.41054-11.02616Zm37.84536-118.35663-2.29934-.001c.00312-4.60182-.15361-9.26028-.46549-13.84366l2.29431-.15493C1068.41977,387.9659,1068.57844,392.67562,1068.57541,397.3304Zm-55.62089,140.06014c-3.2003,3.39759-6.55566,6.72294-9.97393,9.8834l-1.5616-1.68875c3.37914-3.12437,6.69727-6.41232,9.86118-9.77157Zm53.71825-167.99826-2.278.31275c-.62889-4.55969-1.42215-9.1549-2.36007-13.65536l2.25169-.46961C1065.2344,360.13252,1066.0367,364.77931,1066.67277,369.39228Zm-74.31856,187.053c-3.63434,2.92465-7.41129,5.7572-11.22849,8.41911l-1.31492-1.8862c3.77321-2.63192,7.50889-5.43222,11.103-8.32421Zm68.60624-214.4829-2.21377.62129c-1.24412-4.43293-2.65687-8.87776-4.1997-13.21261l2.16585-.772C1058.27365,332.98412,1059.70293,337.4798,1060.96045,341.96239ZM969.349,572.49427c-3.99033,2.39571-8.117,4.6861-12.26656,6.80771l-1.046-2.04746c4.10194-2.09782,8.18265-4.36258,12.12913-6.73184Zm82.21438-256.94-2.10843.91677c-1.83613-4.22267-3.84039-8.4366-5.95909-12.52491l2.04231-1.05766C1047.68,307.02293,1049.707,311.28409,1051.5634,315.55423ZM944.38256,585.25635c-4.28276,1.83287-8.6821,3.54035-13.07419,5.07561l-.75831-2.17021c4.34332-1.51792,8.69225-3.20689,12.92733-5.019Zm94.27691-294.59681-1.96458,1.19337c-2.38989-3.93035-4.95019-7.83359-7.60871-11.60018l1.87814-1.32522C1033.65364,282.736,1036.24248,286.68389,1038.65947,290.65954ZM917.92213,594.50461c-4.4902,1.23354-9.07885,2.3258-13.63707,3.24813l-.45671-2.25394c4.50728-.91185,9.04439-1.992,13.48579-3.21126Zm104.558-326.75843-1.78219,1.45111c-2.91029-3.57469-5.981-7.092-9.12859-10.456l1.67882-1.57022C1016.4318,260.573,1019.53763,264.13022,1022.48017,267.74618ZM890.46093,600.06057c-4.61314.60835-9.30571,1.06349-13.94673,1.35321l-.14284-2.29447c4.58831-.28714,9.2282-.73666,13.78931-1.338Zm112.84784-352.80678-1.566,1.68337c-3.37521-3.14118-6.90282-6.205-10.48577-9.10612l1.447-1.78685C996.32847,240.97809,999.8968,244.07683,1003.30877,247.25379Zm-140.795,354.55139c-4.65765-.03-9.37257-.22392-14.01392-.57481l.1741-2.29293c4.58855.34743,9.24922.53855,13.855.569Zm118.98888-372.204-1.32055,1.88354c-3.77087-2.64376-7.68092-5.18827-11.621-7.5639l1.18721-1.96847C973.73339,224.35491,977.68762,226.92843,981.50267,229.6012ZM834.56082,599.68784c-4.60608-.67109-9.24927-1.51161-13.79948-2.49861l.48726-2.24714c4.49918.97581,9.08949,1.80683,13.64334,2.46988ZM957.498,215.12924l-1.0496,2.04542c-4.09019-2.09776-8.31126-4.08345-12.546-5.90361l.908-2.11189C949.09237,210.9987,953.36108,213.00751,957.498,215.12924ZM807.16647,593.7499c-4.46471-1.29392-8.94937-2.75969-13.32947-4.35666l.78826-2.16031c4.33129,1.58,8.76589,3.029,13.181,4.308Zm123.815-387.51982c-4.34752-1.53153-8.79783-2.93177-13.22706-4.16154l.61446-2.21508c4.48,1.24326,8.98022,2.65909,13.37675,4.207Zm-26.70719-7.41122c-4.51714-.92438-9.11656-1.70357-13.67188-2.31426l.30565-2.27845c4.60691.61729,9.25908,1.40473,13.82778,2.3405Zm-27.47019-3.68c-4.58972-.29435-9.2476-.43329-13.844-.41146l-.01113-2.29918c4.64934-.02191,9.36029.11817,14.00188.41683Zm-27.6875.13346c-4.59281.33953-9.22822.84309-13.77706,1.4954l-.3267-2.27614c4.60108-.65989,9.289-1.16855,13.93384-1.51212Zm-27.42294,3.93248c-4.50687.96553-9.03232,2.09832-13.449,3.36432l-.634-2.209c4.46661-1.28169,9.04329-2.42726,13.60149-3.40433Zm-26.64,7.64088c-4.32795,1.56712-8.65809,3.30421-12.871,5.16334l-.92837-2.10327c4.26074-1.88043,8.63992-3.63715,13.01652-5.22286Zm-25.36123,11.19347c-4.08118,2.14549-8.13677,4.456-12.05338,6.868l-1.20579-1.95731c3.96085-2.43952,8.06226-4.7769,12.1891-6.94574Zm-23.611,14.54119c-3.7526,2.68314-7.45591,5.52595-11.00654,8.4503l-1.46248-1.77453c3.59177-2.95785,7.33635-5.83291,11.13243-8.54625Zm-21.40887,17.638c-3.34935,3.1689-6.62809,6.49364-9.74678,9.8823l-1.69159-1.55708c3.15382-3.42688,6.47072-6.78987,9.85783-9.996Zm-18.7893,20.41538c-2.87623,3.59492-5.66311,7.336-8.28438,11.12036l-1.89047-1.30878c2.65133-3.8281,5.47036-7.61219,8.379-11.24758Zm-15.7819,22.78613c-2.35169,3.9529-4.59844,8.04115-6.678,12.15278l-2.05194-1.03889c2.1033-4.15782,4.3758-8.2927,6.75348-12.28973Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M781.45365,581.90857l-.93481,2.10037c-2.12093-.94392-4.23646-1.92846-6.28847-2.92647l1.0051-2.06733C777.26439,580.00127,779.35642,580.975,781.45365,581.90857Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 266.69446,
  width: 550,
  height: 350.83333,
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M641.227,757.89956c-.26384-.43111-6.48471-10.81833-8.64142-32.38762-1.97819-19.78869-.70617-53.14407,16.59237-99.67209,32.77158-88.14421-7.55239-159.26382-7.96442-159.97224l1.98942-1.15414c.10441.17963,10.50958,18.31234,16.65636,47.18592a205.85648,205.85648,0,0,1-8.52578,114.74207c-32.71544,87.99378-8.39329,129.64927-8.144,130.06018Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 511.41253,
  cy: 305.05216,
  r: 14.94537,
  fill: "#11729c"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 558.54792,
  cy: 360.23506,
  r: 14.94537,
  fill: "#e6e6e6"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 526.3579,
  cy: 397.02366,
  r: 14.94537,
  fill: "#11729c"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 565.44579,
  cy: 428.06404,
  r: 14.94537,
  fill: "#11729c"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 514.86146,
  cy: 476.34907,
  r: 14.94537,
  fill: "#e6e6e6"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M650.25576,758.44968s-14.94536-36.78859,29.89074-64.38Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M631.87528,757.78235s-6.80177-39.12161-59.44635-38.78631Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M482.43237,485.67971a106.38851,106.38851,0,0,1,31.71637,21.4563l9.22748-9.22748a119.151,119.151,0,0,0-37.536-24.94745Z",
  transform: "translate(-117 -140.69444)",
  fill: "#11729c"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M339.02747,550.53866A105.9872,105.9872,0,0,1,360.006,513.33242l-9.2428-9.2428a118.816,118.816,0,0,0-24.3305,43.07428Z",
  transform: "translate(-117 -140.69444)",
  fill: "#11729c"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M534.64783,510.67855l-9.3169,9.31689a105.72766,105.72766,0,0,1,16.16455,32.22614l12.58051-3.37091A118.60685,118.60685,0,0,0,534.64783,510.67855Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M362.89056,492.17531l9.2583,9.25831a105.89423,105.89423,0,0,1,37.06775-20.06409l-3.371-12.58063A118.7428,118.7428,0,0,0,362.89056,492.17531Z",
  transform: "translate(-117 -140.69444)",
  fill: "#11729c"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M334,582.80556a106.39567,106.39567,0,0,1,1.16479-15.70221L322.531,563.7181a119.83923,119.83923,0,0,0,2.204,48.78046l12.57464-3.36939A105.83469,105.83469,0,0,1,334,582.80556Z",
  transform: "translate(-117 -140.69444)",
  fill: "#11729c"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M466.12152,685.54537A105.83539,105.83539,0,0,1,440,688.80556c-3.26331,0-6.4903-.15637-9.67926-.44647l-3.4101,12.72669a119.69008,119.69008,0,0,0,42.5802-2.96589Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M342.87415,625.23788l-12.71863,3.408a119.18774,119.18774,0,0,0,26.4472,39.0362l9.22748-9.22748A106.42818,106.42818,0,0,1,342.87415,625.23788Z",
  transform: "translate(-117 -140.69444)",
  fill: "#11729c"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M557.73883,565.46895l-12.657,3.39142a106.27449,106.27449,0,0,1-1.07129,34.40717l12.59955,3.376a119.95675,119.95675,0,0,0,1.12878-41.17463Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M425.84723,477.75289a106.2881,106.2881,0,0,1,40.47638,2.3623l3.36938-12.57464a119.90749,119.90749,0,0,0-47.23724-2.44476Z",
  transform: "translate(-117 -140.69444)",
  fill: "#11729c"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M413.5,685.45174A105.58742,105.58742,0,0,1,378.92938,669.397l-9.34167,9.34168a118.49819,118.49819,0,0,0,40.54352,19.28558Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M520.29889,670.62527l-9.23639-9.23639a106.30048,106.30048,0,0,1-28.82294,18.627l3.40656,12.71344A119.07423,119.07423,0,0,0,520.29889,670.62527Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M539.39862,619.63149a105.99865,105.99865,0,0,1-16.67773,29.37415L532,658.28475a118.82925,118.82925,0,0,0,20.02789-35.26929Z",
  transform: "translate(-117 -140.69444)",
  fill: "#e6e6e6"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 286.61113,
  width: 58,
  height: 23,
  fill: "#e6e6e6"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 321.61113,
  width: 58,
  height: 23,
  fill: "#11729c"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M527.9685,196.43021s6.53214,21.46274,2.79949,27.99488,6.53213,20.52958,23.32906,13.99744,17.73009-13.99744,17.73009-13.99744-6.53214-10.26479-8.39847-31.72753Z",
  transform: "translate(-117 -140.69444)",
  fill: "#ffb9b9"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M442.58412,406.85837s-33.59385,16.79692-18.66325,39.19282c8.67858,13.01787,25.23923,38.33176,37.58667,57.249a190.92873,190.92873,0,0,1,23.51629,51.2709l2.3521,8.12543,9.33162,11.19795,19.59642-22.3959s-28.928-53.19026-28.928-63.455S464.04686,445.118,464.04686,445.118l23.32907-14.9306S461.24738,400.32623,442.58412,406.85837Z",
  transform: "translate(-117 -140.69444)",
  fill: "#ffb9b9"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M551.76414,464.71445s.93317,26.12855,1.86633,36.39334c.76986,8.46845-6.717,32.18011-4.12115,58.55933a247.96,247.96,0,0,1-.56557,51.278L545.232,644.81482l27.99488,2.79949,9.33163-76.51933s5.599-54.12343,2.79948-71.85352l.93317-37.3265S565.76158,454.44966,551.76414,464.71445Z",
  transform: "translate(-117 -140.69444)",
  fill: "#ffb9b9"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M501.84,356.001s-65.32138,41.99231-66.25454,55.05659c0,0,37.3265-3.73265,38.25966,28.928,0,0,22.3959-8.39846,27.99488-10.26479s35.46017-21.46274,35.46017-21.46274,12.13112,9.33163,12.13112,24.26223-.93317,41.05915,0,42.92548,22.3959-25.19539,40.126-1.86633l12.13111-64.38822s3.73265-39.19282-3.73265-41.99231l-52.2571-19.59641Z",
  transform: "translate(-117 -140.69444)",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 424.49935,
  cy: 39.40543,
  r: 27.99488,
  fill: "#ffb9b9"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M534.50064,229.0909s31.57671,8.33979,35.85135-7.49464c0,0,38.80165,7.49464,45.33379,32.69s-15.86377,85.851-15.86377,87.71728,18.66326,13.06428,10.26479,18.66325-15.86376-.93316-12.13111,6.53214,10.26479,9.33162,4.66581,11.19795-39.19283-27.06171-65.32138-19.59641-39.19282,1.86632-39.19282,1.86632L486.39136,259.40765a23.39074,23.39074,0,0,1,8.31622-20.75868c5.848-4.81344,13.60734-10.01393,21.1298-11.42439,14.93061-2.79949,15.55089-4.332,15.55089-4.332Z",
  transform: "translate(-117 -140.69444)",
  fill: "#d0cde1"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M504.63943,392.39435s8.39847,47.59129,19.59642,41.05915-2.79949-41.05915-2.79949-41.05915Z",
  transform: "translate(-117 -140.69444)",
  fill: "#ffb9b9"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M543.622,398.553s-14.5518,46.08373-1.60254,45.46763,16.4972-37.70323,16.4972-37.70323Z",
  transform: "translate(-117 -140.69444)",
  fill: "#ffb9b9"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M492.04174,560.83019s-6.53214-7.4653-10.26479,2.79949-13.99744,23.32906-13.99744,23.32906-22.3959,25.19539-6.53213,26.12855,38.25966-22.3959,38.25966-22.3959l26.12855-24.26223s-8.66-21.09038-12.72847-21.27656S509.77183,570.16181,492.04174,560.83019Z",
  transform: "translate(-117 -140.69444)",
  fill: "#2f2e41"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M552.69731,638.28268s-6.57635,1.91976-6.08766-6.03884c0,0-23.77355,12.571-17.24141,21.9026s13.99744,18.66325,13.99744,18.66325,34.527,19.59642,37.3265,14.9306,2.79949-13.99743.93316-17.73008-11.198-10.26479-8.39846-15.86377-.93316-20.52957-5.599-20.52957S552.69731,638.28268,552.69731,638.28268Z",
  transform: "translate(-117 -140.69444)",
  fill: "#2f2e41"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M517.06859,156.3785s9.00566-19.51228,26.26653-15.00944,27.017,11.25708,27.76747,18.01133-.37524,16.88563-.37524,16.88563-1.87618-13.88374-13.88373-10.88185-30.76937.75047-30.76937.75047l-3.00188,27.017s-3.37713-4.87807-7.12949-1.87618S505.061,162.38228,517.06859,156.3785Z",
  transform: "translate(-117 -140.69444)",
  fill: "#2f2e41"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M599.822,253.35313s-22.3959,60.65556-20.52957,68.12086,0,8.39847-2.79949,10.26479-10.26479,21.46274-10.26479,21.46274-4.66581,11.19795-8.39846,13.99744-3.73265,10.26479-3.73265,10.26479-9.33163,9.33162-7.4653,11.19795,1.86632,4.66581-1.86633,7.4653-7.4653,6.53214-5.599,7.4653,14.9306,11.19795,18.66325,10.26479-1.86633-4.66582,2.79949-6.53214,7.4653-4.66581,5.599-5.599-7.4653-.93316-1.86632-2.79948,25.19539-13.99744,31.72752-28.928,37.82959-105.264,18.9148-117.95337C615.00416,252.04508,607.28731,242.15518,599.822,253.35313Z",
  transform: "translate(-117 -140.69444)",
  fill: "#d0cde1"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M496.241,243.08834l-.379.1579a23.49829,23.49829,0,0,0-13.9605,16.89678c-2.03768,9.753-4.04256,23.85963-2.45746,37.06875,2.79948,23.32906,4.66581,33.59385,8.39846,41.05915s4.66581,4.66581,3.73265,10.26479-5.599.93316-.93316,8.39846,7.4653,5.599,5.599,9.33163-4.66581,3.73265-.93316,8.39846,3.73265,6.53214,4.66581,8.39846,3.73265,15.86377,3.73265,15.86377,14.9306-4.66582,23.32907-2.79949c0,0-7.46531-13.06428-5.599-15.86376s4.66581-3.73266,1.86633-6.53214-7.46531-1.86633-2.79949-4.66582-3.73265-31.72752-3.73265-31.72752Z",
  transform: "translate(-117 -140.69444)",
  fill: "#d0cde1"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  y: 616.61113,
  width: 966,
  height: 2,
  fill: "#3f3d56"
});

var _ref43 = /*#__PURE__*/React.createElement("polygon", {
  points: "632.752 316.648 631.297 315.276 741.021 198.835 830.335 198.835 830.335 200.835 741.885 200.835 632.752 316.648",
  fill: "#3f3d56"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 769.59146,
  y: 214.12713,
  width: 105.40854,
  height: 3.57317,
  fill: "#11729c"
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 769.59146,
  y: 229.31311,
  width: 105.40854,
  height: 3.57317,
  fill: "#11729c"
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 769.59146,
  y: 244.49908,
  width: 105.40854,
  height: 3.57317,
  fill: "#11729c"
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 758.59146,
  y: 505.12713,
  width: 105.40854,
  height: 3.57317,
  fill: "#11729c"
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 758.59146,
  y: 520.31311,
  width: 105.40854,
  height: 3.57317,
  fill: "#11729c"
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 758.59146,
  y: 535.49908,
  width: 105.40854,
  height: 3.57317,
  fill: "#11729c"
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  points: "819 487.199 713.475 487.199 713.177 486.766 631.177 367.766 632.823 366.632 714.525 485.199 819 485.199 819 487.199",
  fill: "#3f3d56"
});

var SvgPros3 = function SvgPros3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e3d770ae-065d-49c7-8680-9771fb80e313",
    "data-name": "Layer 1",
    width: 966,
    height: 618.61113,
    viewBox: "0 0 966 618.61113",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPros3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pros_3.798c5bf9.svg";
export { ForwardRef as ReactComponent };